<template>
    <v-container fluid>
        <v-row>
            <v-spacer></v-spacer>
            <v-data-table v-model="selected" :headers="$vuetify.breakpoint.mobile ? headersMobile : headers" :items="files"
                :single-select="singleSelect" :mobile-breakpoint="0" item-key="name" show-select class="elevation-1">

                <template v-slot:top>
                    <v-row>
                        <v-col cols="6">
                            <v-switch v-model="singleSelect"
                                :label="!singleSelect ? 'Selección Múltiple' : 'Selección Única'" class="pa-3"
                                color="#05435B" inset></v-switch>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="2" style="display: flex;align-items: center; justify-content: flex-end;">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2" fab dark small color="#05435B" v-bind="attrs" v-on="on"
                                        @click="abrirDialogoCarga">
                                        <v-icon dark>mdi-upload</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cargar archivos</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2" fab dark small color="red" v-bind="attrs" v-on="on"
                                        @click="abrirDialogoEliminarSeleccionados" :disabled="selected.length === 0">
                                        <v-icon dark>mdi-trash-can</v-icon>
                                    </v-btn>
                                </template>
                                <span>Eliminar seleccionados</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </template>

                <!-- Columna de Acciones -->
                <template v-slot:item.acciones="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon color="green" v-bind="attrs" v-on="on" @click="descargarArchivo(item)">
                                <v-icon>mdi-download</v-icon>
                            </v-btn>
                        </template>
                        <span>Descargar archivo</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon color="red" v-bind="attrs" v-on="on" @click="abrirDialogoEliminarFila(item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Eliminar archivo</span>
                    </v-tooltip>
                </template>

            </v-data-table>

            <v-spacer></v-spacer>
        </v-row>

        <!-- Dialogo para Cargar Archivos -->
        <v-dialog v-model="dialogoCarga" max-width="500px" @click:outside="cerrarDialogoCarga">
            <v-card>
                <v-card-title>Cargar Archivos</v-card-title>
                <v-card-text>
                    <v-file-input label="Seleccionar archivos" multiple v-model="inputFile" @change="agregarArchivos"
                        ref="fileInput" outlined dense></v-file-input>

                    <!-- Lista de archivos seleccionados -->
                    <v-list v-if="archivosCargados.length">
                        <v-list-item-group>
                            <v-list-item v-for="(archivo, index) in archivosCargados" :key="index">
                                <v-list-item-content>
                                    <v-list-item-title>{{ archivo.name }} ({{ (archivo.size / (1024 * 1024)).toFixed(2)
                                        }}
                                        MB)</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon color="red" @click="eliminarArchivoCargado(index)">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="green" text @click="confirmarCarga" :disabled="archivosCargados.length === 0">
                        Confirmar Carga
                    </v-btn>
                    <v-btn color="red" text @click="cerrarDialogoCarga">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialogo para Confirmar Eliminación de Seleccionados -->
        <v-dialog v-model="dialogoEliminarSeleccionados" max-width="400px">
            <v-card>
                <v-card-title>Eliminar Archivos Seleccionados</v-card-title>
                <v-card-text>
                    <p>¿Estás seguro de que deseas eliminar los siguientes archivos?</p>
                    <ul>
                        <li v-for="archivo in selected" :key="archivo.name">{{ archivo.name }}</li>
                    </ul>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="red" text @click="confirmarEliminarSeleccionados">Sí, eliminar</v-btn>
                    <v-btn text @click="dialogoEliminarSeleccionados = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialogo para Confirmar Eliminación de una Fila -->
        <v-dialog v-model="dialogoEliminarFila" max-width="400px">
            <v-card>
                <v-card-title>Eliminar Archivo</v-card-title>
                <v-card-text>
                    ¿Estás seguro de que deseas eliminar el archivo <strong>{{ archivoAEliminar.name }}</strong>?
                </v-card-text>
                <v-card-actions>
                    <v-btn color="red" text @click="confirmarEliminarFila">Sí, eliminar</v-btn>
                    <v-btn text @click="dialogoEliminarFila = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import apiService from "@/services/apiService";
import SwalService from '@/services/swalService';
export default {
    data() {
        return {
            singleSelect: false,
            selected: [],
            dialogoCarga: false,
            dialogoEliminarSeleccionados: false,
            dialogoEliminarFila: false,
            archivosCargados: [],
            archivoAEliminar: {},
            inputFile: null,
            headers: [
                { text: 'Nombre de Archivo', value: 'name' },
                { text: 'Fecha de Carga', value: 'formattedLastModified' },
                { text: 'Tamaño de Archivo', value: 'size' },
                { text: 'Acciones', value: 'acciones', sortable: false },
            ],
            headersMobile: [
                { text: 'Nombre de Archivo', value: 'name' },
                { text: 'Acciones', value: 'acciones', sortable: false },
            ],
            files: [
                { name: 'reporte1', formattedLastModified: '2025-01-30', size: '2.3 MB' },
                { name: 'informe_financiero', formattedLastModified: '2025-01-29', size: '1.8 MB' },
                { name: 'proyecto_final', formattedLastModified: '2025-01-28', size: '3.5 MB' },
                { name: 'presentacion', formattedLastModified: '2025-01-27', size: '900 KB' },
                { name: 'analisis_datos', formattedLastModified: '2025-01-26', size: '4.2 MB' }
            ]
        };
    },
    created() {
        this.getFiles();
    },
    methods: {
        abrirDialogoCarga() {
            this.dialogoCarga = true;
        },
        cerrarDialogoCarga() {
            this.dialogoCarga = false;
            this.limpiarArchivosSeleccionados();
        },
        agregarArchivos(event) {
            if (event) {
                this.archivosCargados = [...this.archivosCargados, ...event]; // Agrega archivos sin reemplazar
            }
            this.inputFile = null; // Limpia el input para permitir recarga de archivos
        },
        eliminarArchivoCargado(index) {
            this.archivosCargados.splice(index, 1);
        },
        async confirmarCarga() {
            SwalService.loading('Cargando..', 'Por favor espere.');
            const formData = new FormData();
            for (let file of this.archivosCargados) {
                formData.append("files", file);
            }
            // Enviar los datos y los archivos al endpoint
            const response = await apiService.post("/files/upload-programa", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            await this.getFiles();
            this.limpiarArchivosSeleccionados();
            this.dialogoCarga = false;
        },
        limpiarArchivosSeleccionados() {
            this.archivosCargados = [];
            this.inputFile = null;
            this.$nextTick(() => {
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.reset(); // Reinicia el v-file-input
                }
            });
        },
        abrirDialogoEliminarSeleccionados() {
            if (this.selected.length > 0) {
                this.dialogoEliminarSeleccionados = true;
            }
        },
        async confirmarEliminarSeleccionados() {
            SwalService.loading('Eliminando..', 'Por favor espere.');
            //this.files = this.files.filter(file => !this.selected.includes(file));
            const dataDelete = this.selected.map(item => item.name);
            this.selected = [];
            const response = await apiService.post("/programa-trabajos/delete-files-programa", dataDelete);
            if (response.data.success) {
                await this.getFiles();
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
                SwalService.success('Eliminación Completa', 'Se eliminaron los archivos ' + dataDelete.join(", "));
            } else {
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            this.dialogoEliminarSeleccionados = false;
        },
        abrirDialogoEliminarFila(item) {
            this.archivoAEliminar = item;
            this.dialogoEliminarFila = true;
        },
        async confirmarEliminarFila() {
            SwalService.loading('Eliminando..', 'Por favor espere.');
            //this.files = this.files.filter(file => file.nombre !== this.archivoAEliminar.nombre);
            const dataDelete = [this.archivoAEliminar.name]
            const response = await apiService.post("/programa-trabajos/delete-files-programa", dataDelete);
            if (response.data.success) {
                await this.getFiles();
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
                SwalService.success('Eliminación Completa', 'Se elimino el archivo ' + dataDelete[0]);

            } else {
                SwalService.close();
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            this.dialogoEliminarFila = false;
        },
        descargarArchivo(item) {
            let name = item.name.split(".");
            const url = "https://backend.eamconsulting.com.pe/public-files/" + name[0];
            window.open(url, "_blank");
        },
        async getFiles() {
            SwalService.loading('Cargando..', 'Por favor espere.');
            const response = await apiService.get("/programa-trabajos/get-files-programa")
            if (response.data.fileList.length > 0) {
                this.files = response.data.fileList;
                this.files = this.files.map(item => ({
                    ...item, // Copia los demás atributos
                    size: this.formatSize(item.size)
                }));
            } else {
                this.files = [];
            }
            SwalService.close();
            await new Promise(resolve => setTimeout(resolve, 100));
        },
        formatSize(bytes) {
            if (!bytes || bytes < 0) return "0 Bytes"; // Maneja casos inválidos

            const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
            const i = Math.floor(Math.log(bytes) / Math.log(1024)); // Encuentra la unidad adecuada
            return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`; // Redondea a 2 decimales
        }
    }
}
</script>

<style scoped>
.v-data-table>>>thead th {
    font-weight: bold;
    color: white !important;
    background-color: #05435B;
}
.v-data-table>>>thead th.sortable .v-data-table-header__icon {
    color: white !important;
    font-weight: 700;
}
</style>